import { format, isToday, isTomorrow, isYesterday } from 'date-fns';

export function getRelativeWeekDay(datetime: string): string {
  const date = new Date(datetime);
  if (isToday(date)) {
    return 'Today';
  }

  if (isTomorrow(date)) {
    return 'Tomorrow';
  }

  if (isYesterday(date)) {
    return 'Yesterday';
  }

  return format(date, 'EEEE');
}
